import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from './useAuth';

export function useDeal(dealId) {
  const { currentUser } = useAuth();
  const [deal, setDeal] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser || !dealId) {
      setDeal(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    const dealRef = doc(db, 'deals', dealId);

    const unsubscribe = onSnapshot(
      dealRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const dealData = {
            id: snapshot.id,
            ...snapshot.data()
          };
          // Verify this deal belongs to the current user
          if (dealData.ownerId === currentUser.uid) {
            setDeal(dealData);
          } else {
            setError('Unauthorized access to this deal');
            setDeal(null);
          }
        } else {
          setError('Deal not found');
          setDeal(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching deal:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [currentUser, dealId]);

  return deal;
}
